module.exports = __webpack_public_path__ + "static/F5_bg_01-6606db98951fd64a522395b2b0a5e08d.png";